module.exports = __webpack_public_path__ + "static/media/sessions.afa88d49.png";